module.exports = __webpack_public_path__ + "static/media/pizzaPolloMaiz.cc5fd515.png";